import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Analytics – sends a Google Analytics 4 `page_view` event on every
 * React Router route change. The gtag script itself is loaded in
 * public/index.html with send_page_view disabled so we control timing
 * and avoid duplicate counts on first load.
 *
 * Admin routes (`/admin/...`) are excluded from tracking.
 */
const GA_ID = "G-DDBKVWJSPZ";

export default function Analytics() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;

    const path = location.pathname + location.search;
    if (path.startsWith("/admin")) return;

    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
      send_to: GA_ID,
    });
  }, [location.pathname, location.search]);

  return null;
}
